import classes from "./MyContainer.module.css";


export const MyContainer = ({ children }) => {
  return (
    <div className={classes.container}>
      <div className={classes.table}>
        <div className={classes.table_body}>
          <div className={classes.area_container}>
            {Array.isArray(children)
              ? children.map((e, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      margin:
                        i === 0 ? "1rem 0rem 1rem 0rem" : "1rem 0rem 1rem 1rem",
                    }}
                  >
                    {e}
                  </div>
                ))
              : children}
          </div>
        </div>
      </div>
    </div>
  );

};
